import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo3d.png';
import { useAlert } from 'react-alert';
import { client } from '../client';
import jwt_decode from "jwt-decode";
import { getAuth, getRedirectResult, GoogleAuthProvider, signInWithPopup, signInWithRedirect } from 'firebase/auth';
import GoogleButton from 'react-google-button';
import Spinner from './Spinner';

const Login = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  const [loading, setLoading] = useState();
  const [signIn, setSignIn] = useState(false);
  const alert = useAlert();


  const handelClick = () => {
    setLoading(true);
    console.log("signIn");
    // signInWithPopup(auth, provider)
    // signInWithRedirect(auth, provider);
    signInWithPopup(auth, provider)
    .then((result) => {
      const credential = GoogleAuthProvider.credentialFromResult(result);
      var userObject = jwt_decode(credential.idToken);
      localStorage.setItem('user', JSON.stringify(userObject));
      const { name, sub, picture } = userObject;

      const doc = {
        _id: sub,
        _type: 'user',
        userName: name,
        image: picture,
        profImage: picture,
      };
      alert.show(
        <div style={{ color: 'white' }}>
            Logged in
        </div>);

      client.createIfNotExists(doc).then(() => {
        navigate('/home', { replace: true });
      });

      setLoading(false);
      navigate('/home', { replace: true });

    }).catch((error) => {
      console.log("error");
      // console.log(error);
      // console.log(error.message);
      // setLoading(false);
      // alert.show(
      //   <div style={{ color: 'white' }}>
      //       Error Loggin You In. Apple Sucks
      //   </div>);

    });
    setSignIn(true);
  }

  useEffect(() => {
   
      console.log('Requesting permission...');
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        }
      });

  }, [])

  // useEffect(() => {

  //   getRedirectResult(auth)
  //     .then((result) => {
  //       const credential = GoogleAuthProvider.credentialFromResult(result);
  //       var userObject = jwt_decode(credential.idToken);
  //       localStorage.setItem('user', JSON.stringify(userObject));
  //       const { name, sub, picture } = userObject;

  //       const doc = {
  //         _id: sub,
  //         _type: 'user',
  //         userName: name,
  //         image: picture,
  //         profImage: picture,
  //       };
  //       alert.show(
  //         <div style={{ color: 'white' }}>
  //             Logged in
  //         </div>);

  //       client.createIfNotExists(doc).then(() => {
  //         navigate('/home', { replace: true });
  //       });

  //       setLoading(false);
  //       navigate('/home', { replace: true });

  //     }).catch((error) => {
  //       console.log("error");
  //       // console.log(error);
  //       // console.log(error.message);
  //       // setLoading(false);
  //       // alert.show(
  //       //   <div style={{ color: 'white' }}>
  //       //       Error Loggin You In. Apple Sucks
  //       //   </div>);

  //     });
  // }, [])

  // const responseGoogle = (response) => {
  //   var userObject = jwt_decode(response.credential);
  //   localStorage.setItem('user', JSON.stringify(userObject));

  //   console.log(response.credential);
  //   console.log(userObject);

  //   const { name, sub, picture } = userObject;

  //   const doc = {
  //     _id: sub,
  //     _type: 'user',
  //     userName: name,
  //     image: picture,
  //     profImage: picture,
  //   };
  //   client.createIfNotExists(doc).then(() => {
  //     navigate('/home', { replace: true });
  //   });
  // }

  // useEffect(() => {
  //   /* global google*/
  //   google.accounts.id.initialize({
  //     client_id: `${process.env.REACT_APP_GOOGLE_API_TOKEN}`,
  //     callback: responseGoogle
  //   })

  //   google.accounts.id.renderButton(
  //     document.getElementById("signInDiv"),
  //     { theme: "outline", size: "large" }
  //   )
  // }, []);

  return (
    <div className="flex justify-start items-center flex-col h-screen">
        <div className='absolute z-50 top-60 w-full'>
        {loading && (
          <Spinner message={"loggin in..."}/>
        )}
        </div>

      <div className=" relative w-full h-full">
        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0    bg-blackOverlay">
          <div className="p-5">
            <img src={logo} width="260px" />
          </div>
          <GoogleButton onClick={handelClick} />
        </div>
      </div>

    </div >
  );
};

export default Login
